// Static exchange rates (updated December 2025)
// Base currency: EUR = 1.00
export const EXCHANGE_RATES = {
  EUR: 1.00,
  USD: 1.09,
  GBP: 0.86,
  UAH: 43.50,
  BRL: 6.20,
  JPY: 163.00,
  CHF: 0.94,
  CAD: 1.51,
  AUD: 1.67,
  CNY: 7.85,
} as const;

export const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  UAH: '₴',
  BRL: 'R$',
  JPY: '¥',
  CHF: 'CHF',
  CAD: 'CA$',
  AUD: 'A$',
  CNY: '¥',
} as const;

/**
 * Convert amount from one currency to another using static exchange rates
 * @param amount - The amount to convert
 * @param fromCurrency - The source currency code
 * @param toCurrency - The target currency code
 * @returns Converted amount rounded to 2 decimal places
 */
export const convertCurrency = (
  amount: number,
  fromCurrency: string,
  toCurrency: string
): number => {
  if (fromCurrency === toCurrency) return amount;
  
  const fromRate = EXCHANGE_RATES[fromCurrency as keyof typeof EXCHANGE_RATES] || 1;
  const toRate = EXCHANGE_RATES[toCurrency as keyof typeof EXCHANGE_RATES] || 1;
  
  // Convert to EUR first (base currency), then to target currency
  const inEUR = amount / fromRate;
  const converted = inEUR * toRate;
  
  return Math.round(converted * 100) / 100; // Round to 2 decimals
};

/**
 * Format currency amount with appropriate symbol
 * @param amount - The amount to format
 * @param currency - The currency code
 * @returns Formatted currency string (e.g., "€10.00")
 */
export const formatCurrency = (amount: number, currency: string): string => {
  const symbol = CURRENCY_SYMBOLS[currency as keyof typeof CURRENCY_SYMBOLS] || currency;
  return `${symbol}${amount.toFixed(2)}`;
};
